
import React from 'react';
import {connect} from 'react-redux';
import { ProgressBar } from 'react-bootstrap';
import axios from 'axios';

class ProcessData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            progress:30,
            isActiveClass: '',
            timeout: null,
        }
        // this.requested = false;
    }
    // static async getDerivedStateFromProps(props, state){
            
    // }
    // getSnapshotBeforeUpdate(prevProps, prevState){
        
    // }
    async UNSAFE_componentWillMount(){
        // console.log('sending',this.props.getForm());
        let response = {};
        try{
         response = await axios({
            method: 'post',
            url: '/92know/calculate',
            data: this.props.form
          });
        }catch(ex){
            console.log(ex);

        }
          this.setState({
            progress:100,
            isActiveClass: '',
            timeout: null,
        });
        setTimeout(() => {
            this.props.updateResponse(response.data,'response');
        },500);
    }
    // async componentDidUpdate() {
    //     console.log('component did update');
        // const { timeout } = this.state;
        // if(this.props.isActive && !timeout && !this.requested){
        //     this.requested = true;
            // console.log('sending',this.props.getForm);
            // const response = await axios({
            //     method: 'post',
            //     url: '/92know/calculate',
            //     data: this.props.getForm()
            //   });
            // this.props.updateResponse(response.data,'response');
            // this.setState({
            //     progress:100,
            //     isActiveClass: 'loaded',
            //     timeout: setTimeout(() => {
            //         this.props.nextStep();
            //         this.setState({
            //             progress:30,
            //             isActiveClass: '',
            //             timeout: null,
            //         });
            //         this.requested = false;
            //     }, 500),
            // });
        // }
        // else if (!this.props.isActive && timeout) {
        //     clearTimeout(timeout);
        //     this.setState({
        //         isActiveClass: '',
        //         timeout: null,
        //     });
        // }
    // }
    // componentWillUnmount() {
    //     console.log('unmount called')
    //     this.setState({
    //         progress:30,
    //         isActiveClass: '',
    //         timeout: null,
    //     });
    //     this.requested = false;
    // }
  
    render() {
        return (
            <div className="row">
                <div className={`col-md-6 col-sm-12 offset-sm-3`}>
                    <p className='text-center'>Generating Report...</p>            
                    <ProgressBar animated variant="success" now={this.state.progress} />
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    return {
        form,
        ...ownProps
    };
}
 export default connect(
    mapStateToProps,
    null
  )(ProcessData)